module.exports = __webpack_public_path__ + "img/check.c87ba8c8.png";